type PlainObject = { [key: string]: unknown };

function isObject(item: unknown): item is PlainObject {
  return !!item && typeof item === "object" && !Array.isArray(item);
}

export function deepMerge<T extends object>(target: T, source: Partial<T>): T {
  const output = { ...target } as T;

  for (const key in source) {
    if (isObject(source[key])) {
      if (!(key in target)) {
        (output as Record<string, unknown>)[key] = source[key];
      } else if (isObject(target[key])) {
        (output as Record<string, unknown>)[key] = deepMerge(
          target[key] as object,
          source[key] as Partial<object>,
        );
      } else {
        (output as Record<string, unknown>)[key] = source[key];
      }
    } else {
      (output as Record<string, unknown>)[key] = source[key];
    }
  }

  return output;
}
